import vipUser from '@api/vip'
import loginApis from '@api/login'

export default {
  namespaced: true,
  state: {
    userName: false,
    isLogin: false,
    isSubAccount: 0, //1 子账号， 0 主账号（已创建子账号）， -1 主账号（未创建过子账号）
    bookSize: {
      bookHeight: null,
      bookWidth: null
    },
    appSize: {
      width: null,
      height: null
    },
    bookScale: 1.41,
    goodsObj: {
      period: 0,
      creator: '',
      chargeBook: '',
      worksName: '',
      chargePage: 0,
      worksId: '',
      price: '',
      cover: '',
      worksType: '',
      secret: 0,
      trialPercent: 0,
      trialOption: 0,
      articlePrice: ''
    },
    goodsObjList: [],
    isOrdered: false,
    isStaticBook: false,
    vipInfo: {
      isMember: false,
      authProduct: '免费版',
      endTime: Date.now()
    },
    // 会员权益
    vipRight: {
      id: 10000,
      name: '免费版', //"等级"
      videoNum: 0, //视频数量
      videoSize: 100, //视频大小
      bookSize: null, //书刊（PDF）大小
      linkWork: 0, // 链接作品是否支持
      price: 0, //"价格"
      spaceNum: 0, //"存储"
      bookNum: 50, //"作品数量"
      albumNum: 5, //"专辑数量"
      libNum: 2, //"图书馆数量"
      pv: 0, //"访问数据"
      uv: 0, //"访客分析"
      batchUpload: 0, // 批量上传
      mergeUpload: 0, //合并上传
      pageSound: 1, //"翻书音效"
      addCatalog: 1, //"添加目录"
      customBg: 0, //"自定义背景图"
      autoCatalog: 0, //"自动生成目录"
      customAdornment: 0, //"自定义封面标签"
      linkQrCode: 1, //"网页链接及二维码"
      embedWebsite: 0, //"嵌入用户自定义网站"
      textRetrieval: 1, //"文字内容检索"
      browseMemory: 1, //"浏览位置记忆"
      viewLastContent: 0, //"查看往期内容"
      poster: 0, //"开启作品海报"
      downloadPdf: 0, //"开启下载PDF"
      downloadHtml: 0, //"开启下载HTML"
      bgMusic: 0, //"开启背景音乐"
      customWechatShare: 1, //"自定义微信分享描述"
      replaceLoadingLogo: 0, //"更换加载页logo图片"
      replaceBookLogo: 0, //"更换电子书logo图片"
      replaceLogoLink: 0, //"更换电子书logo链接"
      streamFormat: 0, //流式
      downloadEpub: 0, //是否开启下载eupb
      buttonStyle: 1, //按钮风格
      buyLink: 0, //购买链接
      questionnaire: 0, //问卷
      status: 1,
      productType: null,
      childAccountNum: null, //子账号数量
      epaperClassifyNum: 0, // 报纸分类数量
      epaperPub: 0, // 是否支持发布数字报（0否1是）
      epaperRichMedia: 0 // 是否支持富媒体（0否1是）
    },
    isChart: true,
    isList: false,
    isBookChart: true,
    isBookList: false
  },
  mutations: {
    UPDATE_USER_NAME(state, name) {
      state.userName = name
    },
    UPDATE_IS_SUB_ACCOUNT(state, isSubAccount) {
      state.isSubAccount = isSubAccount
    },
    UPDATE_BOOK_SIZE(state, size) {
      state.bookSize = size
    },
    UPDATE_APP_SIZE(state, size) {
      state.appSize = size
    },
    UPDATE_BOOK_SCALE(state, scale) {
      state.bookScale = scale
    },
    UPDATE_BOOK_STATUS(state, status) {
      state.isStaticBook = status
    },
    UPDATE_GOODS_OBJ(state, obj) {
      state.goodsObj[obj.type] = obj.value
    },
    UPDATE_GOODS_OBJS(state, obj) {
      state.goodsObj = obj
    },
    UPDATE_GOODS_OBJ_LIST(state, obj) {
      state.goodsObjList = [...obj]
    },
    UPDATE_IS_ORDERED(state, val) {
      state.isOrdered = val
    },
    UPDATE_IS_LOGIN(state, val) {
      state.isLogin = val
    },
    UPDATE_VIP_INFO(state, info) {
      state.vipInfo = info
    },
    UPDATE_VIP_RIGHT(state, right) {
      state.vipRight = right
    },
    UPDATE_IS_CHART(state, isChart) {
      state.isChart = isChart
    },
    UPDATE_IS_LIST(state, isList) {
      state.isList = isList
    },
    UPDATE_IS_BOOK_CHART(state, isBookChart) {
      state.isBookChart = isBookChart
    },
    UPDATE_IS_BOOK_LIST(state, isBookList) {
      state.isBookList = isBookList
    }
  },
  actions: {
    login({ commit, getters }) {
      return new Promise((reslove, reject) => {
        const userName = getters.userName
        if (!userName) {
          loginApis.login().then((res) => {
            if (res && res.data && res.status === 200) {
              let data = res.data
              if (data.code === 101) {
                localStorage.setItem('username', '')
                commit('UPDATE_IS_SUB_ACCOUNT', 0)
                commit('UPDATE_USER_NAME', false)
                commit('UPDATE_IS_LOGIN', false)
                window.location.href = data.data
              } else {
                localStorage.setItem('username', data.data.username)
                localStorage.setItem('isChild', data.data.isChild)
                commit('UPDATE_IS_SUB_ACCOUNT', data.data.isChild)
                commit('UPDATE_USER_NAME', data.data.username)
                commit('UPDATE_IS_LOGIN', true)
                reslove(true)
              }
            }
          })
        } else {
          reslove(true)
        }
      })
    },
    // 获取会员相关信息
    getVipInfo({ state, commit, getters }) {
      return new Promise((reslove, reject) => {
        const userName = getters.userName
        const isChild = getters.isSubAccount
        if (userName) {
          const params = {
            username: userName,
            isChild: isChild
          }
          vipUser.getVipMsn(params).then((res) => {
            if (res.status === 200) {
              if (res.data.code === 0) {
                commit('UPDATE_VIP_INFO', { ...res.data.data, isMember: true })
                reslove(true)
              } else {
                commit('UPDATE_VIP_INFO', { isMember: false, authProduct: '免费版', endTime: Date.now() })
                reslove(false)
              }
            } else {
              alert(res.data.msg)
              reslove(false)
            }
          })
        }
      })
    },
    // 获取单项VIP权益(免费版为非会员，type传free)
    getVipRight({ state, commit, getters }, type) {
      return new Promise((reslove, reject) => {
        vipUser.getVipRight({ proType: type }).then((res) => {
          if (res.status === 200 && res.data.data) {
            if (res.data.data.length > 0) {
              commit('UPDATE_VIP_RIGHT', { ...res.data.data[0] })
              reslove(true)
            } else {
              // 购买的用户可得到对应的会员权益，若商品还未被绑定会员权益，则仍然为免费版权益。
              vipUser.getVipRight({ proType: 'free' }).then((res) => {
                if (res.status === 200 && res.data.data) {
                  commit('UPDATE_VIP_RIGHT', { ...res.data.data[0] })
                  reslove(true)
                } else {
                  console.log(res.data.msg || '获取权限接口失败')
                  reslove(false)
                }
              })
            }
          } else {
            console.log(res.data.msg || '获取权限接口失败')
            reslove(false)
          }
        })
      })
    }
  },
  getters: {
    // 获取本地用户名信息
    userName: (state) => {
      return state.userName || localStorage.getItem('username')
    },
    isSubAccount: (state) => {
      return Math.max(state.isSubAccount, localStorage.getItem('isChild'))
    }
  }
}
